import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

export default function Hero() {
  const wrapRef = useRef(null);
  const heroContentRef = useRef(null);

  // Floating golden particles
  useEffect(() => {
    const particles = [];
    for (let i = 0; i < 35; i++) {
      const p = document.createElement("i");
      p.className = "particle";
      p.style.left = Math.random() * 100 + "vw";
      p.style.top = 70 + Math.random() * 35 + "vh";
      p.style.animationDuration = 5 + Math.random() * 8 + "s";
      p.style.animationDelay = -Math.random() * 8 + "s";
      p.style.setProperty("--s", 0.5 + Math.random() * 1.5);
      document.body.appendChild(p);
      particles.push(p);
    }
    return () => particles.forEach((p) => p.remove());
  }, []);

  // Mouse parallax on the bee
  useEffect(() => {
    let mx = 0,
      my = 0,
      tx = 0,
      ty = 0,
      raf;

    const onMove = (e) => {
      mx = (e.clientX / window.innerWidth - 0.5) * 2;
      my = (e.clientY / window.innerHeight - 0.5) * 2;
    };
    document.addEventListener("mousemove", onMove);

    const animate = () => {
      tx += (mx - tx) * 0.035;
      ty += (my - ty) * 0.035;
      if (wrapRef.current) {
        wrapRef.current.style.transform = `translate3d(${tx * 22}px, ${ty * 16}px, 0) rotateX(${ty * -4}deg) rotateY(${tx * 7}deg)`;
      }
      raf = requestAnimationFrame(animate);
    };
    animate();

    return () => {
      document.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  // Scroll parallax on hero copy
  useEffect(() => {
    const onScroll = () => {
      if (heroContentRef.current) {
        heroContentRef.current.style.transform = `translateY(${window.scrollY * 0.12}px)`;
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section className="hero" id="home">
      <div className="hex-grid" />

      <div className="bee-wrap" ref={wrapRef}>
        <div className="bee">
          <div className="wing left" />
          <div className="wing right" />
          <div className="body" />
          <div className="head">
            <div className="eye" />
            <div className="antenna" />
          </div>
          <div className="stinger" />
          <div className="leg one" />
          <div className="leg two" />
        </div>
      </div>

      <div className="hero-content" ref={heroContentRef}>
        <div className="eyebrow">EST. 1990 · PURE · RARE · GOLDEN</div>
        <h1>BeeLuxe</h1>
        <p className="tagline">
          Nature's finest honey, elevated into a luxury experience. Pure golden
          nectar, carefully harvested and crafted for those who appreciate the
          extraordinary.
        </p>
        <Link className="cta" to="/shop">
          DISCOVER THE GOLD <span>→</span>
        </Link>
      </div>

      <div className="honey">
        <svg viewBox="0 0 1440 180" preserveAspectRatio="none">
          <path
            d="M0 70 Q120 110 240 70 T480 70 T720 70 T960 70 T1200 70 T1440 70 V180 H0Z"
            fill="#c88d18"
            opacity=".13"
          />
          <path
            d="M0 100 Q120 135 240 100 T480 100 T720 100 T960 100 T1200 100 T1440 100 V180 H0Z"
            fill="#f6c453"
            opacity=".06"
          />
        </svg>
      </div>
    </section>
  );
}
